import { render, staticRenderFns } from "./ProductRejected.vue?vue&type=template&id=2440087a&"
import script from "./ProductRejected.vue?vue&type=script&lang=js&"
export * from "./ProductRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports